import { SubmissionOptions } from '@sky-distribution/gp-onboarding-generic-submission';

export const submissionOptions: SubmissionOptions = {
  propertyKey: 'dwelling',
  propertyCoveragesKey: 'dwellingCoverages',
};
